{
  "title": "We value your privacy",
  "description": "We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
  "acceptAll": "Accept All",
  "rejectAll": "Reject Non-Essential",
  "customize": "Customize",
  "preferencesTitle": "Cookie Preferences",
  "back": "Back",
  "savePreferences": "Save Preferences",
  "alwaysActive": "Always Active",
  "categories": {
    "essential": {
      "name": "Essential",
      "desc": "Required for the site to function properly."
    },
    "analytics": {
      "name": "Analytics",
      "desc": "Helps us understand how you use the site."
    },
    "marketing": {
      "name": "Marketing",
      "desc": "Used for personalized advertising."
    }
  }
}
